import { computed, type Ref } from 'vue'
import type { Alert } from '../model/alert'

export function useAlertInitiator(alert: Ref<Alert>) {
  return computed(() => {
    const alertVal = alert.value

    if (alertVal.type === 'message') {
      return alertVal.message.sender
    }

    if (alertVal.type === 'ping') {
      return alertVal.message.sender
    }

    if (alertVal.type === 'reply') {
      return alertVal.reply.sender
    }

    if (alertVal.type === 'reaction') {
      return alertVal.reaction?.sender ?? null
    }

    return null
  })
}
